export default __webpack_public_path__ + "static/media/slide2.51f6be01.jpg";